<script setup>
import { computed } from 'vue'
import { Label, useForwardProps } from 'radix-vue'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  for: { type: String, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: String, required: false },
})

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <Label v-bind="{ ...forwardedProps }" :class="['form-label', props.class]">
    <slot />
  </Label>
</template>

<style lang="scss" scoped>
.form-label.form-check-label {
  margin-bottom: 0;
}
</style>
